import React from 'react';
import NewsletterUnsubscribe from './NewsletterUnsubscribe';

const NewsletterSubscribe = props => {
  return (
    <NewsletterUnsubscribe
      isSubscribed={true}
      {...props}
    />
  );
};

export default NewsletterSubscribe;



// WEBPACK FOOTER //
// ./containers/NewsletterUnsubscribe/NewsletterSubscribe.js